import { createTheme } from '@mui/material/styles';

const LIGHT_BLUE_VIBRANT = '#00BFFF'; // Bright Sky Blue
const LIGHT_PURPLE_VIBRANT = '#9932CC'; // Vibrant Medium Orchid Purple

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: LIGHT_BLUE_VIBRANT,
            dark: '#009ACD',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: LIGHT_PURPLE_VIBRANT,
            dark: '#800080',
            contrastText: '#FFFFFF',
        },
        background: {
            default: '#F0F2F5',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#212121',
            secondary: '#616161',
        },
        divider: '#E0E0E0',
    },

    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h3: { fontWeight: 700, color: '#212121' },
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 500 },
        button: {
            textTransform: 'none',
            fontWeight: 600,
        },
    },

    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: `linear-gradient(135deg, ${LIGHT_BLUE_VIBRANT}, ${LIGHT_PURPLE_VIBRANT})`,
                    color: '#FFFFFF',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    backdropFilter: 'blur(10px)',
                },
            },
        },

        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(255, 255, 255, 0.25)',
                    border: '1px solid rgba(255, 255, 255, 0.4)',
                    color: '#FFFFFF',
                    fontWeight: 600,
                    backdropFilter: 'blur(8px)',
                },
            },
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 10,
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        transform: 'translateY(-2px)',
                    },
                },
                containedPrimary: {
                    background: `linear-gradient(135deg, ${LIGHT_BLUE_VIBRANT}, ${LIGHT_PURPLE_VIBRANT})`,
                    color: '#FFFFFF',
                    '&:hover': {
                        opacity: 0.9,
                        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
                    },
                },
                containedSecondary: {
                    background: `linear-gradient(135deg, ${LIGHT_PURPLE_VIBRANT}, ${LIGHT_BLUE_VIBRANT})`,
                    color: '#FFFFFF',
                    '&:hover': {
                        opacity: 0.9,
                        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
                    },
                },
            },
        },

        MuiCard: {
            styleOverrides: {
                root: {
                    // Removed transparency overrides as they are fixed in FormA.js for the final look
                    borderRadius: 16,
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        transform: 'translateY(-6px)',
                        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.15)',
                    },
                },
            },
        },

        MuiAccordion: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E0E0E0',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
                    '&:before': { display: 'none' },
                    '&.Mui-expanded': { margin: '0 0 16px 0' },
                },
            },
        },

        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    backgroundColor: '#F8F8F8',
                    color: '#212121',
                    borderBottom: '1px solid #E0E0E0',
                    '& .MMuiTypography-root': { fontWeight: 600 },
                    '& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root': {
                        color: LIGHT_PURPLE_VIBRANT,
                    },
                },
            },
        },

        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF',
                    padding: '16px 24px',
                },
            },
        },

        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    '&::-webkit-scrollbar': {
                        width: 8,
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: LIGHT_PURPLE_VIBRANT,
                        borderRadius: 8,
                    },
                    '&::-webkit-scrollbar-track': {
                        background: 'rgba(0,0,0,0.05)',
                    },
                    // 💥 FIX: Set background to pure white and remove filters
                    background: '#FFFFFF', 
                    backdropFilter: 'none',
                },
            },
        },
    },
});

export default theme;//theme js